import { gql, QueryHookOptions, useQuery } from '@apollo/client';

import { GetMessageThreadForMaintenanceRequest } from '../../../athena/types/GetMessageThreadForMaintenanceRequest';
import { WebNoteFields } from '../../../fragments/web/WebNoteFields';

export const GET_MESSAGE_THREAD_FOR_MAINTENANCE_REQUEST = gql`
  query GetMessageThreadForMaintenanceRequest($requestId: String!) {
    webMaintenance {
      getMessageThread(
        input: { requestType: { requestIdentifier: { maintenanceRequestId: $requestId } } }
      ) {
        messageThread {
          id
          notes {
            ...WebNoteFields
          }
        }
      }
    }
  }
  ${WebNoteFields}
`;

const useGetMessageThreadForMaintenanceRequest = (
  options?: QueryHookOptions<GetMessageThreadForMaintenanceRequest>,
) =>
  useQuery<GetMessageThreadForMaintenanceRequest>(
    GET_MESSAGE_THREAD_FOR_MAINTENANCE_REQUEST,
    options,
  );

export default useGetMessageThreadForMaintenanceRequest;
